module.exports = __webpack_public_path__ + "img/garantia.4a3fd860.png";